<template>
  <el-container type="flex" class="main_container">
    <base-header>
      <div class="a-title">
        <div>
          <el-input
            style="width: 200px;"
            v-model="keyword"
            placeholder="请输入手机号/昵称/ID">
          </el-input>
          <el-button
            @click="search"
            :loading="searchLoading">
            搜索
          </el-button>
          <el-button
            @click="reset"
            :loading="resetLoading">
            重置
          </el-button>
        </div>
        <el-button @click="openDialog" type="primary" style="margin-left: 100px;">添加品牌商</el-button>
      </div>
    </base-header>
    <el-main>
      <el-table
        :data="branderList"
        height="100%"
        v-loading="tableLoading">
        <el-table-column label="品牌头像和昵称" >
          <template v-slot="scope">
            <div class="clickable" @click="(scope.row.client_id)">
              <img v-if="scope.row.shop_pic" :src=scope.row.shop_pic>
              {{scope.row.shop_name}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="client_id" label="userID" align="left" width="80">
        </el-table-column>
        <el-table-column label="微信头像和昵称" width="140">
          <template v-slot="scope">
            <div class="clickable" @click="toUserManager(scope.row.client_id)">
              <img v-if="scope.row.avatar_url" :src=scope.row.avatar_url>
              {{scope.row.nickname}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号码" align="center"></el-table-column>
        <el-table-column label="显示官方店" width="140">
          <template v-slot="scope">
            <el-switch v-model="scope.row.show_txm_shop" @change="changeSwitch($event, scope.row, 'bmclient/show_txm_shop')"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="VIP品牌商" width="140">
          <template v-slot="scope">
            <el-switch v-model="scope.row.vip_brander" @change="changeSwitch($event, scope.row, 'bmclient/set_vip_brander')"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="售后客服转换" width="140">
          <template v-slot="scope">
            <el-switch v-model="scope.row.after_sale_customer" @change="changeSwitchCS($event, scope.row, 'bmclient/after_sale_customer')"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="上级团长" width="140">
            <template v-slot="scope">
              <div>
                <img v-if="scope.row.branch_client_avatar_url" :src=scope.row.branch_client_avatar_url>
                {{scope.row.branch_client_nickname}}
              </div>
            </template>
        </el-table-column>
        <el-table-column label="打印机编号" width="140">
          <template v-slot="scope">
            <div
              v-for="(item, index) in scope.row.printer_no"
              :key="item.printer_info_id"
            >
              <div
                v-show="!item.changingPrinter"
                class="clickable"
                @click="showPrinterInput(scope.row, index)"
              >
                {{item.printer_no}}
                <span style="color: dodgerblue;">换绑</span>
              </div>
              <el-input
                v-show="item.changingPrinter"
                style="width: 80px;"
                v-model="printer_no"
                @blur="item.changingPrinter = false"
                @change="changePrinter(scope.row, index)"
              />
            </div>
            <div
              v-show="((scope.row.printer_no.length < 2 && scope.row.is_repast_seller) || scope.row.printer_no.length === 0) && !scope.row.printerInput"
              class="clickable"
              @click="showPrinterInput(scope.row, -1)"
            >
              <span style="color: dodgerblue;">新增</span>
            </div>
            <el-input
              v-show="scope.row.printerInput"
              style="width: 80px;"
              v-model="printer_no"
              @blur="scope.row.printerInput = false"
              @change="changePrinter(scope.row, -1)"
            />
          </template>
        </el-table-column>
        <el-table-column label="商品数">
          <template v-slot="scope">
            <div style="display: inline">{{scope.row.goods_count}}</div>
            <span @click="openCount(scope.row.client_id)">查看</span>
          </template>
        </el-table-column>
        <el-table-column prop="become_brander_time" label="添加时间" align="center"></el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer">
      <el-pagination
        :total="totalCount"
        :page-size="pagesize"
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </el-footer>
      <el-dialog :visible.sync="dialogVisible" width="300px" :title="dialogStatus ? '确认用户信息' : '请输入查询信息'">
      <div style="display: flex; flex-direction: column; align-items: center">
        <el-input v-model="branderNickname" v-if="!dialogStatus" placeholder="请输入微信昵称" class="padding width-200"></el-input>
        <el-input v-model="branderPhone" v-if="!dialogStatus" placeholder="请输入电话号码" class="padding width-200"></el-input>
        <div v-else style="display: flex; justify-content: space-around; align-items: center; width: 80%; padding-bottom: 20px;">
          <div>{{branderInfo.client_id}}</div>
          <div style="display: flex; max-width: 120px; align-items: center">
            <img :src="branderInfo.avatar_url">{{branderInfo.nickname}}
          </div>
        </div>
        <div>
          <el-button
            type="primary"
            @click="clickDialogButton"
            :loading="dialogButtonLoading"
            :disabled="!this.branderNickname && !this.branderPhone">
            {{dialogStatus ? '确认添加' : '查找'}}
          </el-button>
          <el-button v-if="dialogStatus" @click="resetDialogInfo">返回</el-button>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import pageMixin from '../../../mixins/page'
import getTokenMixin from '../../../mixins/getToken'

export default {
  name: 'BranderList',
  mixins: [pageMixin, getTokenMixin],
  data () {
    return {
      getBranderListUrl: this.getDomain() + 'bmclient/get_brander_list', // 品牌商列表
      searchUserUrl: this.getDomain() + 'bmclient/search_user', // 查询想成为品牌商的
      becomeBranderUrl: this.getDomain() + 'bmclient/become_brander  ', // 成为品牌商
      branderList: [],
      keyword: undefined,
      tableLoading: true,
      searchLoading: false,
      resetLoading: false,
      dialogVisible: false,
      branderNickname: undefined,
      branderPhone: undefined,
      dialogStatus: false,
      dialogButtonLoading: false,
      branderInfo: {},
      value: true,
      printer_no: undefined
    }
  },
  methods: {
    // 发布接龙个数
    openCount (clientId) {
      this.$router.push({
        name: 'client-regiment',
        params: {
          client_id: clientId
        }
      })
    },
    getList () {
      this.tableLoading = true
      let params = {
        page: this.page,
        pagesize: this.pagesize,
        keyword: this.keyword
      }
      let handle = res => {
        this.totalCount = res.data.content.total_count
        this.branderList = res.data.content.brander_list
        this.branderList.forEach(item => {
          item.become_brander_time = this.timeTransform(item.become_brander_time)
          this.$set(item, 'vip_brander', !!item.vip_brander)
          this.$set(item, 'show_txm_shop', !item.not_show_txm_shop)
          this.$set(item, 'after_sale_customer', !!item.after_sale_customer)
          this.$set(item, 'printerInput', false)
          item.printer_no.forEach(priter => {
            this.$set(priter, 'changingPrinter', false)
          })
        })
      }
      let loadings = () => {
        this.tableLoading = false
        this.searchLoading = false
        this.resetLoading = false
      }
      this.__axios(this.getBranderListUrl, params, handle, loadings)
    },
    // 搜索
    search () {
      this.searchLoading = true
      this.page = 1
      this.getList()
    },
    // 重置
    reset () {
      this.resetLoading = true
      this.keyword = undefined
      this.page = 1
      this.getList()
    },
    openDialog () {
      this.dialogVisible = true
      this.dialogStatus = false
    },
    clickDialogButton () {
      this.dialogButtonLoading = true
      if (this.dialogStatus) {
        this.becomeBrander()
      } else {
        this.searchUser()
      }
    },
    resetDialogInfo () {
      this.dialogStatus = false
    },
    becomeBrander () {
      let params = {
        client_id: this.branderInfo.client_id
      }
      let handle = () => {
        this.$message.success('添加成功')
        this.getList()
      }
      let loading = () => {
        this.dialogButtonLoading = false
      }
      this.__axios(this.becomeBranderUrl, params, handle, loading)
    },
    searchUser () {
      let params = {
        nickname: this.branderNickname || '',
        phone: this.branderPhone || ''
      }
      let handle = res => {
        if (!res.data.content.client_list.length) {
          this.$message.error('不存在此用户')
        } else if (res.data.content.client_list.length > 1) {
          this.$message.error('搜到多个用户，请换条件重试')
        } else {
          this.branderInfo = res.data.content.client_list[0]
          this.dialogStatus = true
        }
      }
      let loading = () => {
        this.dialogButtonLoading = false
      }
      this.__axios(this.searchUserUrl, params, handle, loading)
    },
    changeSwitch ($event, row, url) {
      let params = {
        client_id: row.client_id,
        not_show_txm_shop: !$event,
        vip_brander: $event
      }
      let handle = () => {
        this.$message.success('操作成功')
      }
      let onCancel = () => {
        if (url === 'bmclient/set_vip_brander') {
          row.vip_brander = !$event
        } else {
          row.show_txm_shop = !$event
          row.not_show_txm_shop = $event
        }
      }
      let info = '确认？'
      if (url === 'bmclient/set_vip_brander') {
        info = $event ? `是否要将“${row.nickname}”设置为VIP品牌商？` : `是否要取消“${row.nickname}”的VIP品牌商身份？`
      }
      this.__confirm(info, this.__axios, [this.getDomain() + url, params, handle, () => {}, onCancel], onCancel)
    },
    changeSwitchCS ($event, row, url) {
      let params = {
        client_id: row.client_id,
        after_sale_customer: $event
      }
      let handle = () => {
        this.$message.success('操作成功')
      }
      let onCancel = () => {
        row.after_sale_customer = !$event
      }
      let info = '确认？'
      this.__confirm(info, this.__axios, [this.getDomain() + url, params, handle, () => {}, onCancel], onCancel)
    },
    showPrinterInput (row, index) {
      this.branderList.forEach(item => {
        item.printer_no.forEach(priter => {
          priter.changingPrinter = false
        })
        item.printerInput = false
      })
      if (index === -1) {
        row.printerInput = true
      } else {
        row.printer_no[index].changingPrinter = true
      }
    },
    changePrinter (row, index) {
      if (this.printer_no) {
        let params = {
          printer_no: this.printer_no,
          client_id: row.client_id
        }
        if (index !== -1) {
          params.printer_info_id = row.printer_no[index].printer_info_id
        }
        let handle = res => {
          this.$message.success('绑定成功')
          if (index !== -1) {
            row.printer_no[index].printer_no = this.printer_no
            row.printer_no[index].changingPrinter = false
          } else {
            row.printer_no.push({
              printer_info_id: res.data.content.printer_info_id,
              printer_no: this.printer_no,
              changingPrinter: false
            })
            row.printerInput = false
          }
          this.printer_no = undefined
        }
        this.__axios(this.getDomain() + 'bmuser/add_brander_printer', params, handle)
      } else {
        index === -1 ? row.printerInput = false : row[index].changingPrinter = false
      }
    }
  },
  created () {
    this.getList()
  }
}
</script>

<style scoped>
  span {
    color: #3a8ee6;
    cursor: pointer;
  }

  img {
    width: 30px;
    height: 30px;
  }

  .a-title {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .padding {
    padding: 10px;
  }

  .width-200 {
    width: 200px;
  }
</style>
